module.exports = __webpack_public_path__ + "img/laugh.ad91e571.gif";